import axios from "axios";
import {  message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;
// const testUrl = "http://localhost:8080";

export const get_companies = async (token, type_search, other = undefined) => {
	let body = {
		token,
		type_search
	};

	if (other != undefined) {
		body.data = other;
	}

	try {
		const res = await axios.post(`${apiUrl}/get_companies`, body);
		if (res.status == 200) return res.data;
		else message.error(res.data);
		return [];
	} catch (err) {
		message.error(err.response.data);
	}
};

export const reload_nomenclature = async (token, company_id) => {
	// eslint-disable-next-line no-useless-catch
	try {
		const body = {
			token,
			company_id
		};
		const res = await axios.post(`${apiUrl}/nomenclature_notificator`, body);
		return res;
	} catch (err) {
		message.error(err.response.data);
	}
};

export const edit_company = async (token, data, edit_value) => {
	try {
		const res = await axios.post(`${apiUrl}/edit_company`, {
			token,
			edit_value,
			data
		});
		if (res.status == 200) return res.data;
		else message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};
